import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Truck, Facebook, Instagram, Twitter } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { name: "House Removals", href: "/services/house-removals" },
    { name: "Office Removals", href: "/services/office-removals" },
    { name: "Man and Van", href: "/services/man-and-van" },
    { name: "Storage Solutions", href: "/services/storage" },
    { name: "Specialist Moves", href: "/services/specialist-moves" },
  ];

  const companyLinks = [
    { name: "About Us", href: "/about" },
    { name: "Reviews", href: "/reviews" },
    { name: "Areas We Cover", href: "/areas-we-cover" },
    { name: "FAQs", href: "/faq" },
    { name: "Contact", href: "/contact" },
  ];

  const legalLinks = [
    { name: "Terms & Conditions", href: "/terms" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Cookie Policy", href: "/cookies" },
  ];

  return (
  <>
    <footer className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-white/10 flex items-center justify-center">
                <Truck className="w-6 h-6 text-[#FF5A1F]" />
              </div>
              <div>
                <span className="font-bold text-xl font-['Outfit'] tracking-tight text-white">HITECH</span>
                <span className="font-bold text-xl font-['Outfit'] tracking-tight text-[#FF5A1F]">TRANSIT</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Professional removal services across Cardiff, Wales, London and England. 
              Trusted by thousands of customers for safe, reliable moves.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com/hitechtransit" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#FF5A1F] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/hitechtransit" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#FF5A1F] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://twitter.com/hitechtransit" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#FF5A1F] transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-slate-400 mb-6">Our Services</h3>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-300 hover:text-[#FF5A1F] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-slate-400 mb-6">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-slate-300 hover:text-[#FF5A1F] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-xs tracking-[0.2em] uppercase font-bold text-slate-400 mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:07346209593" className="flex items-start gap-3 text-sm text-slate-300 hover:text-[#FF5A1F] transition-colors">
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>07346 209593</span>
                </a>
              </li>
              <li>
                <a href="mailto:hello@hitechtransit.com" className="flex items-start gap-3 text-sm text-slate-300 hover:text-[#FF5A1F] transition-colors">
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>hello@hitechtransit.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-300">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>Cardiff & London<br />Serving Wales & England</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-max px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {currentYear} Hitech Transit. All rights reserved.
            </p>
            <p className="text-xs text-slate-500 mt-1">
              Company Registration No. 12345678 &middot; VAT No. GB 123 4567 89
            </p>
            <div className="flex gap-6">
              {legalLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
    {/* Spacer for mobile sticky CTA bar */}
    <div className="h-16 lg:hidden" aria-hidden="true" />
  </>
  );
};

export default Footer;
